// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/speci-criteria.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/speci-criteria/speci-criteria.js';

mount([g0]);
